import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as _ from 'lodash';

@Component({
	selector: 'bt-ids-filter-list',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatButtonModule, MatInputModule, CommonModule, MatNativeDateModule, MatDatepickerModule],
	templateUrl: './ids-filter-list.component.html',
	styleUrl: './ids-filter-list.component.scss'
})
export class IdsFilterListComponent implements OnInit {
	readonly #dialogRef = inject(MatDialogRef<IdsFilterListComponent>);
	data = inject(MAT_DIALOG_DATA);

	ids: Array<number> = [];

	ngOnInit(): void {
		this.data = _.cloneDeep(this.data);

		if (this.data.selected.length == 0) {
			this.ids = [null];
		} else {
			this.ids = this.data.selected;
		}
	}

	removeId(index: number): void {
		this.ids.splice(index, 1);
	}

	addId(): void {
		this.ids.push(0);
	}

	onClose(): void {
		this.#dialogRef.close();
	}
}
